@use '@styles' as *;

.avatar {
    color: $primary;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    background-color: $grey-100;

    & svg path {
        fill: $grey-400;
    }
}

.avatar-popover {
    .ant-popover-container,
    .ant-popover-content .ant-popover-inner {
        padding: 4px 0;
        min-width: 160px;
    }

    .ant-popover-content {
        & .avatar-popover-content {
            & .ant-popover-inner {
                padding: 0;
            }

            &__list {
                padding: 0;
                list-style: none;
                margin: 0;

                &-item {
                    padding: 2px 0;

                    & > button {
                        padding: 6px 20px;
                        width: 100%;
                        text-align: left;
                        transition:
                            background-color 0.2s,
                            color 0.2s;

                        @include T15;

                        &:hover {
                            background-color: $primary-100;
                            color: $primary;
                        }

                        &:active {
                            background-color: $primary-200;
                            color: $primary;
                        }
                    }
                }
            }
        }
    }
}
